import React from "react";
import { MyCalendar } from "../component/calenderComponent";
import "./../style/calenderStyle.css";
import { LocalStorage } from "../../../utils/Utils";

function ProgramSchedulePage() {
  return (
    <div>
      <div className="desktop-ui_assessmentCheck">
        <div
          className="center-card"
          style={{
            height:
              LocalStorage.getLocalData("fromFlutter") !== "true"
                ? "88vh"
                : "100vh",
          }}
        >
          <MyCalendar />
        </div>
      </div>
      <div className="mobile-ui_assessmentCheck">
        <p>The Learning schedule is not accessible on mobile devices.</p>{" "}
      </div>
    </div>
  );
}

export default ProgramSchedulePage;
